import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable()
export class LoaderService {
  isLoading = new BehaviorSubject<boolean>(false);
  handler:BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  timer: any;
  show() {
    this.isLoading.next(true);
    clearTimeout(this.timer);
    this.timer = setTimeout(() => {
    }, 500);
  }

  hide() {
    clearTimeout(this.timer);
    this.isLoading.next(false);
  }
}
